import React, { ReactElement } from 'react';
import { Button } from 'elmo-elements';

const Buttons = (props: {
  isButtonsVisible: boolean;
  onReset: () => void;
  onSubmit: () => void;
}): ReactElement => {
  if (!props.isButtonsVisible) {
    return <div />;
  }

  return (
    <div className="elmoca-sort__buttons">
      <div className="container-buttons mt-2 float-right">
        <Button type="default" onClick={props.onReset} className="mr-2">
          Reset
        </Button>
        <Button type="primary" onClick={props.onSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default Buttons;
